/**
 * Rewards referral claim trigger.
 *
 * Smile UI shows the referred friend's "claim your coupon" prompt only
 * while it initialises on a page whose URL carries the referral
 * parameters (`smile_referral_code`, `st_intent`). There is no deep link
 * or API to reopen it, so a "Claim my gift" button re-runs that moment:
 * the parameters are remembered on arrival and the page is reloaded
 * with them when the button is pressed.
 *
 * Buttons opt in with `data-rewards-claim-trigger`. When no referral
 * parameters were ever seen (a direct visit), the click falls through
 * to the button's own href / Smile deep link.
 */
const STORAGE_KEY = 'rewards:smile-referral';
const PARAM_PREFIXES = ['smile_', 'st_'];

function referralParamsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const kept = new URLSearchParams();

  params.forEach((value, key) => {
    if (PARAM_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      kept.set(key, value);
    }
  });

  return kept.has('smile_referral_code') ? kept : null;
}

function rememberReferralParams() {
  const params = referralParamsFromUrl();
  if (!params) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, params.toString());
  } catch {
    // Storage blocked: the URL still carries the parameters for this visit.
  }
}

function storedReferralParams() {
  const fromUrl = referralParamsFromUrl();
  if (fromUrl) return fromUrl;

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return stored ? new URLSearchParams(stored) : null;
  } catch {
    return null;
  }
}

function reopenClaimPrompt(event) {
  const params = storedReferralParams();
  if (!params) return;

  event.preventDefault();

  const url = new URL(window.location.href);
  url.hash = '';
  params.forEach((value, key) => url.searchParams.set(key, value));

  if (url.href === window.location.href) {
    window.location.reload();
  } else {
    window.location.assign(url.href);
  }
}

function init() {
  rememberReferralParams();

  document.querySelectorAll('[data-rewards-claim-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', reopenClaimPrompt);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
